import { render } from "./JobDetailModal.vue?vue&type=template&id=8fdb05f2&scoped=true&ts=true"
import script from "./JobDetailModal.vue?vue&type=script&lang=ts"
export * from "./JobDetailModal.vue?vue&type=script&lang=ts"

import "./JobDetailModal.vue?vue&type=style&index=0&id=8fdb05f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fdb05f2"]])

export default __exports__